"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _taggedTemplateLiteral = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _excluded = ["bodyRemoveTag", "bodyProps", "className", "customInfos", "customInfosProps", "children", "description", "descriptionProps", "display", "params", "title", "titleProps", "titleParams"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importStar(require("react"));

var index_1 = require("../../index");

var convertParams_1 = __importDefault(require("../../utils/convertParams"));

var CustomInfosSC = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var GroupSC = styled_1.default.fieldset(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
var GroupBodySC = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
var GroupDescriptionSC = styled_1.default.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));
var LegendSC = styled_1.default.legend(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));

var Group = function Group(_ref) {
  var _ref$bodyRemoveTag = _ref.bodyRemoveTag,
      bodyRemoveTag = _ref$bodyRemoveTag === void 0 ? false : _ref$bodyRemoveTag,
      bodyProps = _ref.bodyProps,
      className = _ref.className,
      customInfos = _ref.customInfos,
      customInfosProps = _ref.customInfosProps,
      children = _ref.children,
      description = _ref.description,
      descriptionProps = _ref.descriptionProps,
      display = _ref.display,
      params = _ref.params,
      title = _ref.title,
      titleProps = _ref.titleProps,
      titleParams = _ref.titleParams,
      props = _objectWithoutProperties(_ref, _excluded);

  var _ref2 = (0, react_1.useContext)(index_1.FormidableContext),
      t = _ref2.t,
      sc = _ref2.sc;

  var GroupBodyCmp = 'inside' === display || bodyRemoveTag ? react_1.default.Fragment : GroupBodySC;
  var groupBodyProps = 'inside' === display || bodyRemoveTag ? {} : _objectSpread(_objectSpread({}, bodyProps), {}, {
    as: sc && sc.groupBody
  });
  var TitleCmp = title && react_1.default.createElement(LegendSC, _objectSpread({
    as: sc && sc.groupTitle,
    "data-display": display
  }, titleProps), t ? t(title, (0, convertParams_1.default)(titleParams, params)) : title);
  var DescriptionCmp = description ? react_1.default.createElement(GroupDescriptionSC, _objectSpread({
    as: sc && sc.groupDescription
  }, descriptionProps), t ? t(description) : description) : undefined;
  var CustomInfosCmp = customInfos ? react_1.default.createElement(CustomInfosSC, _objectSpread({
    as: sc && sc.groupCustomInfos
  }, customInfosProps), customInfos) : undefined;
  return react_1.default.createElement(GroupSC, _objectSpread({
    as: sc && sc.group,
    className: className,
    "data-display": display
  }, props), (customInfos || title && description) && react_1.default.createElement("div", null, CustomInfosCmp, TitleCmp, DescriptionCmp), !customInfos && title && !description && TitleCmp, !customInfos && !title && description && DescriptionCmp, react_1.default.createElement(GroupBodyCmp, _objectSpread({}, groupBodyProps), children));
};

exports.default = Group;